import { Component, OnInit } from '@angular/core';

import { HelpService } from '@services/help.service';
import { Video } from '@classes/video';

@Component({
    selector: 'app-tutorial',
    templateUrl: './tutorial.component.html',
    styleUrls: ['./tutorial.component.scss']
})
export class TutorialComponent implements OnInit {
    videos: Video[];

    constructor(
        private helpSrv: HelpService
    ) {}

    ngOnInit() {
        this.helpSrv.getVideos()
        .subscribe(videosFromSrv => {
            this.videos = videosFromSrv;
        });
    }

}
